import { api } from "./client";

export type FoundPrinter = {
  address: string;
  kinds: string[];
  name?: string;
  make_model?: string;
  ipp_path?: string;
  driverless: boolean;
};

export type PrinterTask = {
  id: string;
  type: string;
  status: "pending" | "running" | "succeeded" | "failed" | "expired" | "cancelled";
  error_message: string;
  result: {
    printers?: FoundPrinter[];
    drivers?: string[];
    models?: string[];
    name?: string;
    driver?: string;
  };
};

export type InstallRequest =
  | { address: string; mode: "driverless"; ipp_path: string; name: string }
  | { address: string; mode: "driver"; driver: string; name: string };

type Ticket = { task_id: string };

export async function discoverPrinters(agentId: string) {
  return (await api.post<Ticket>(`/agents/${agentId}/printers/discover`)).data;
}

export async function listDrivers(agentId: string) {
  return (await api.post<Ticket>(`/agents/${agentId}/printers/drivers`)).data;
}

export async function installPrinter(agentId: string, req: InstallRequest) {
  return (await api.post<Ticket>(`/agents/${agentId}/printers/install`, req)).data;
}

export async function uploadDriverPackage(agentId: string, file: File) {
  const form = new FormData();
  form.append("file", file);
  return (
    await api.post<Ticket>(`/agents/${agentId}/printers/driver-package`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data;
}

/** Waits for a printer task to finish (the PC does the work in the background). */
export async function waitForTask(taskId: string, timeoutMs = 16 * 60_000): Promise<PrinterTask> {
  const started = Date.now();
  while (Date.now() - started < timeoutMs) {
    await new Promise((r) => setTimeout(r, 2000));
    let task: PrinterTask;
    try {
      task = (await api.get<PrinterTask>(`/agents/printer-tasks/${taskId}`)).data;
    } catch {
      continue; // a dropped poll on office WiFi; try again
    }
    if (task.status !== "pending" && task.status !== "running") return task;
  }
  throw new Error("The computer didn't answer in time. Try again.");
}
